import React from "react";

function GradientText({ children, rest, className }) {
  return (
    <h1
      className={`bg-sandAgainBtn inline-block text-transparent bg-clip-text ${className}`}
      {...rest}
    >
      {children}
    </h1>
  );
}

export default GradientText;
